<template>
    <b-card class="inner-block asset-type-view">
        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex">
                    <b-input v-model="filter" type="text" :placeholder="$translate('search_asset_type')"></b-input>
                    <slot></slot>
                </b-col>


            </b-row>
        </b-card-header>

        <b-card-body class="p-2">
            <b-col class="page-block"><strong>{{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }} {{
                Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
                    :current-page="currentPage" :filter="filter">
                    <template #cell(id)="row">
                        <b-button v-if="hasPermissionView" @click="$emit('show-item', row.item.id)" class="mr-2"
                            variant="pink-button">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="currentPage" :total-rows="rows"
                        :per-page="itemsPerPage" aria-controls="roleTable" :prev-text="$translate('previous')"
                        :next-text="$translate('next')" pills align="center"></b-pagination>

                </b-col>
            </b-row>



        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'EmailScheduler-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() { },

    methods: {},

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                { key: 'description', label: this.$translate('description') },
            ]
        },

        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
    },
}
</script>
<style></style>
